import React from 'react';

const Advantages = () => {
  const advantages = [
    {
      icon: 'fa-certificate',
      bgColor: 'bg-primary',
      title: 'Sertifikat Lengkap',
      description: 'Semua produk kami dilengkapi sertifikat halal MUI, sertifikat kesehatan hewan, dan sertifikat organik dari lembaga resmi.',
      linkText: 'Lihat Sertifikat'
    },
    {
      icon: 'fa-truck',
      bgColor: 'bg-secondary',
      title: 'Pengiriman Aman',
      description: 'Sistem logistik terintegrasi dengan armada khusus untuk memastikan produk sampai dalam kondisi prima dan tepat waktu.',
      linkText: 'Tracking Pengiriman'
    },
    {
      icon: 'fa-headset',
      bgColor: 'bg-accent',
      textColor: 'text-primary',
      title: 'Layanan 24/7',
      description: 'Tim customer service kami siap melayani Anda 24/7 untuk memastikan kepuasan dan kemudahan dalam setiap transaksi.',
      linkText: 'Hubungi Kami'
    },
    {
      icon: 'fa-shield-alt',
      bgColor: 'bg-primary',
      title: 'Garansi Kualitas',
      description: 'Kami memberikan garansi 100% uang kembali jika produk tidak sesuai dengan spesifikasi yang dijanjikan.',
      linkText: 'Syarat & Ketentuan'
    },
    {
      icon: 'fa-chart-line',
      bgColor: 'bg-secondary',
      title: 'Harga Kompetitif',
      description: 'Dengan kemitraan langsung dengan petani, kami dapat menawarkan harga terbaik tanpa mengorbankan kualitas.',
      linkText: 'Bandingkan Harga'
    },
    {
      icon: 'fa-leaf',
      bgColor: 'bg-accent',
      textColor: 'text-primary',
      title: 'Ramah Lingkungan',
      description: 'Praktik pertanian berkelanjutan dan kemasan ramah lingkungan sebagai wujud kepedulian terhadap bumi.',
      linkText: 'Program Hijau'
    }
  ];

  return (
    <section id="keunggulan" className="pt-20 sm:pt-24 pb-16 sm:pb-20 bg-light-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center bg-accent/20 text-primary px-3 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            <i className="fa-solid fa-star mr-2"></i>
            Mengapa Memilih Kami
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            Keunggulan yang<br className="hidden sm:block"/>
            <span className="text-secondary">Membedakan Kami</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            Dengan pengalaman bertahun-tahun dan komitmen kualitas, 
            kami menjadi pilihan terpercaya untuk kebutuhan agribisnis Anda.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {advantages.map((advantage, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 sm:p-7 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 group">
              <div className={`w-14 h-14 sm:w-16 sm:h-16 ${advantage.bgColor} ${advantage.textColor || 'text-white'} rounded-2xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`fa-solid ${advantage.icon} text-xl sm:text-2xl`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-primary mb-3 sm:mb-4">{advantage.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base mb-5 sm:mb-6">
                {advantage.description}
              </p>
              <div className="flex items-center text-accent font-medium text-sm sm:text-base">
                <span>{advantage.linkText}</span>
                <i className="fa-solid fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-primary to-secondary rounded-3xl p-8 sm:p-10 lg:p-12 text-white text-center">
          <h3 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Bergabunglah dengan Ribuan Pelanggan Puas</h3>
          <div className="grid sm:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-accent mb-1 sm:mb-2">98%</div>
              <div className="text-sm sm:text-lg">Tingkat Kepuasan</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-accent mb-1 sm:mb-2">5000+</div>
              <div className="text-sm sm:text-lg">Pelanggan Aktif</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-accent mb-1 sm:mb-2">24/7</div>
              <div className="text-sm sm:text-lg">Layanan Support</div>
            </div>
          </div>
          <button className="bg-accent text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:bg-yellow-400 transition-colors">
            Mulai Berbelanja Sekarang
          </button>
        </div>
      </div>
    </section>
  );
};

export default Advantages;

